module.exports = __webpack_public_path__ + "static/docsBackDesktop-fccefedb6c1e25f2661c9e6b4b222237.png";